import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import { IAPIResponse } from "@mindmemobile/mm-shared-global";
import {
  IAPIFundRaiserSummaryModel,
  IAPIAgencySummaryModel,
  IAPIAdminGridSummaryRequest,
} from "../interfaces";
import AdminAuthStore from "../store/AdminAuthStore";

class FundRaiserService {
  private httpService: HttpService;

  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  // Admin/bulk use case: fund raisers across ALL accounts in one call, paged and filtered
  // server-side. AdminApiKey is a static shared secret forwarded from Main_Web2's admin-only
  // build via postMessage.
  getFundRaisersSummary(
    request: IAPIAdminGridSummaryRequest
  ): Observable<IAPIResponse<IAPIFundRaiserSummaryModel[]>> {
    return this.httpService.post<IAPIResponse<IAPIFundRaiserSummaryModel[]>>(
      url.getFundRaisersSummary,
      request,
      { headers: { AdminApiKey: AdminAuthStore.adminApiKey } }
    );
  }

  // Same shared agency list as MerchantAccountService.getMerchantAccountAgencies() - kept as
  // its own method here so the fund raiser grid doesn't need to import a differently-named service.
  getFundRaiserAgencies(): Observable<IAPIResponse<IAPIAgencySummaryModel[]>> {
    return this.httpService.post<IAPIResponse<IAPIAgencySummaryModel[]>>(
      url.getAgencies,
      {},
      { headers: { AdminApiKey: AdminAuthStore.adminApiKey } }
    );
  }
}

export default new FundRaiserService();
